export {makeCnVariants} from '@eitje/utils'

export const validCssSize = size => {
	const knownUnits = ['em', 'rem', 'px', 'vh', '%', 'vw', 'calc(', 'auto', 'unset']

	if (!isNaN(size)) return `${size}px`

	return typeof size === 'string' && knownUnits.some(unit => size.includes(unit)) && size
}

export const formatCssVars = obj => {
	return Object.keys(obj).reduce((result, key) => {
		result['--' + key] = obj[key]
		return result
	}, {})
}
